import { useTranslation } from "react-i18next";
import { CiFaceFrown } from "react-icons/ci";
import { humanizeError } from "../../utils/errorText";

const ErrorDisplay = ({ error, onRetry }) => {
  const { t } = useTranslation();

  return (
    <div
      className="w-full flex flex-col justify-center items-center gap-3 min-h-[16rem] px-4 text-center"
      role="alert"
    >
      <h1 className="text-base sm:text-lg font-normal text-[var(--tx-2)] Poppins max-w-prose">
        {humanizeError(error, t)}
      </h1>
      <CiFaceFrown
        className="text-7xl text-[var(--tx-2)]"
        aria-hidden="true"
      />
      {onRetry && (
        <button
          type="button"
          className="text-white bg-[--primary] hover:bg-[--primary-hover] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
          onClick={onRetry}
        >
          {t("404.tryagain")}
        </button>
      )}
    </div>
  );
};

export default ErrorDisplay;
